<div *ngIf="data.treatment.lockscreen">
  <ion-card *ngIf="data.treatment.lockscreen.questionnaire.questionnaire.type === 'block'" class="ion-padding black-text">
    <div *ngIf="step === 1" class="step1">
      <h2 class="title-button" expand="full" color="success">{{ 'lockscreen.important_title' | translate }}</h2>  
      <div class="ion-padding big-thumbs icon-box" >
        <app-messagebubble [text]="('lockscreen.previously_yes' | translate:{ name: data.user.name })"></app-messagebubble>
        <p class="pre_wrap" [innerHTML]="'lockscreen.previously_yes_html' | translate:{ name: data.user.name }"></p>
      </div>
      <ul>
        <li *ngFor="let q of answered_yes">
          <ion-label><div [innerHTML]="q.question.title"></div></ion-label>
        </li>
      </ul>

    <p [innerHTML]="data.treatment.lockscreen.output.question"></p>

      <div><span [innerHTML]="'lockscreen.safe_intro' | translate"></span><br /><br />
        <span [innerHTML]="'lockscreen.press_yes' | translate"></span><br /><br />
        <span [innerHTML]="'lockscreen.press_no' | translate"></span><br /><br />
      </div>
      <ion-row>
          <ion-col class="ion-text-center" size="12">
            <ion-button (click)="unlock()" expand="block" color="success">{{ 'common.yes' | translate }}</ion-button>
            <ion-button (click)="step = 2; data.setEventsAnalytics('No Still not Seen Clinician','event', {product_zone: 'Screening and symptom checker', questionnaire_id: data.treatment.lockscreen.questionnaire.questionnaire.id})" expand="block" color="danger">{{ 'common.no' | translate }}</ion-button>
          </ion-col>
      </ion-row>
    </div>
    <div *ngIf="step === 2" class="step2">
      <h2 class="title-button" expand="full" color="success">{{ 'lockscreen.safety_title' | translate }}</h2>  
      <div class="ion-padding big-thumbs icon-box gub-italic home-box message-box" >
        <app-messagebubble [text]="('lockscreen.safety_intro' | translate:{ name: data.user.name }) + ' ' + data.boxes.lockscreen.lock.text"></app-messagebubble>
        <p class="pre_wrap" [innerHTML]="'lockscreen.safety_intro' | translate:{ name: data.user.name }"></p>
        <div class="custom-html"[innerHTML]="data.boxes.lockscreen.lock.text"></div>
      </div>
      <ion-row>
          <ion-col class="ion-text-center" size="12">
            <ion-button (click)="step = 1" expand="block" color="success">{{ 'common.ok' | translate }}</ion-button>
          </ion-col>
      </ion-row>
    </div>
  </ion-card>
  <ion-card class="ion-padding" *ngIf="data.treatment.lockscreen.questionnaire.questionnaire.type === 'numeric'" >
      <div id="drMacText">
          <div id="drMacPic"></div>
          <div id="drMacUserPic"></div>
          <div class="home-message" class="pre-wrap" [innerHTML]="data.boxes.lockscreen.lock.text"></div>
      </div>
      <ion-row>
          <ion-col size="12">
              <ion-label>{{ 'lockscreen.symptoms_resolved' | translate }}</ion-label>
          </ion-col>
          <ion-col class="ion-text-center" size="12">
              <ion-button routerLink="/questionnaire" expand="block" color="success">{{ 'common.yes' | translate }}</ion-button>
              <ion-button (click)="step = 2" expand="block" color="danger">{{ 'common.no' | translate }}</ion-button>
          </ion-col>
      </ion-row>
  </ion-card>
</div>
